/**
 * useWorkingStages - the board reopen-target derivation (SE-5496), extracted
 * from MainContainer to keep it under the repo max-lines-per-function ceiling.
 *
 * The board's working (non-terminal) stages, mapped to the reopen dialog's
 * option shape. A closed card can only reopen into one of these; terminal
 * stages are excluded upstream in useKanbanBoard.
 * @module features/player-kanban/hooks/useWorkingStages
 */
import { useMemo } from "react";

import type { ReopenStageOption } from "../components/molecules/ReopenCardDialog";
import type { KanbanPhase } from "@/generated/graphql";

/**
 * Maps working (non-terminal) phases to reopen-dialog options.
 * @param workingPhases - The board's non-terminal phases.
 * @returns Reopen-dialog options, memoized on workingPhases.
 */
export const useWorkingStages = (
  workingPhases: readonly KanbanPhase[]
): ReopenStageOption[] =>
  useMemo(
    () =>
      (workingPhases ?? []).map(phase => ({ id: phase.id, name: phase.name })),
    [workingPhases]
  );
